module.exports = __webpack_public_path__ + "static/media/Click.4e9d9bc4.mp3";